/**
 * resource component to display content module information in 
 * card form 
 * 
 * NOTE: unused in 1.15
 */

// import primary libraries
import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { Link, history, withRouter } from 'react-router-dom';

// import third-party libraries
import _ from 'lodash';
import ReactTooltip from 'react-tooltip';

// import global components
import AlertModal from '../../../global/components/modals/AlertModal.js.jsx';
import Base from "../../../global/components/BaseComponent.js.jsx";
import Modal from '../../../global/components/modals/Modal.js.jsx';
import VideoPlayer from "../../../global/components/helpers/VideoPlayer.js.jsx";

import * as userModuleActions from '../../userModule/userModuleActions';

// import utilities
import videoUtils from '../../../global/utils/videoUtils';

const simUrl = window.simUrl;
// not updating links here because this should no longer be used with london handling agenda
class AgendaTmCard extends Base {
  constructor(props) {
    super(props);
    this.state = {
      trailerModalOpen: false 
    }
    this._bind(
      '_handleStartOver'
    )
  }

  _handleStartOver() {
    // TODO: athens 2.0 investigate
    const { dispatch, history, contentModule } = this.props;
    dispatch(userModuleActions.sendCreateUserModule({
      _contentModule: contentModule._id
    })).then(json => {
      if(json.success) {
        // TODO: CHECK IF WE TO INVALIDATE THE LIST OR ANYTHING HERE
        // created new one, now send them to it
        history.push(`/my-agenda/cms/${contentModule.slug}`)
      } else {
        alert(`ERROR: ${json.error}`);
      }
    })
  }

  render() {

    const {
      agendaItem
      , sponsorStore 
      , contentModule
    } = this.props;
  
    const {
      trailerModalOpen
    } = this.state;
  
    const pending = agendaItem.certificateStatus == "pending-attestation";
    const expired = agendaItem.certificateStatus == "expired"; 
    const expiringSoon = agendaItem.certificateStatus == 'expiring-soon'; 
    const completed = agendaItem._certificate ? true : false;  
    const required = !agendaItem.optional;
  
    const sponsor = sponsorStore.byId[contentModule._organization];
    let logoUrl = contentModule.brandingLogoUrl ? contentModule.brandingLogoUrl : (sponsor && sponsor.logo) ? sponsor.logo : "/img/cert-icons/cert-icon-empty@2x.png"; 

    // let linkUrl = match.url; 
    let linkUrl = `/my-agenda`

    return (
      <div className="tm-card-wrapper">
      {/* Move all ReactTooltips to the root div of this component so that the stacking context allows the tooltip to display on top of everything else. */}

        <ReactTooltip
          aria-haspopup='true'
          id={`trailer-${contentModule._id}`}
          place="top"
          type="dark"
        >
          <p>Play simulation trailer</p>
        </ReactTooltip>
        <ReactTooltip
          aria-haspopup='true'
          id={`certificate-${contentModule._id}`}
          place="top"
          type="dark"
        >
          <p>View & print certificate</p>
        </ReactTooltip>
        <div id={`tm_${contentModule._id}`} className="card tm-card -bordered">
          <div>
            <div className="-cert">
              { agendaItem.valid ?
                <div >
                  <img className="u-pullLeft" alt="certificate achieved" src={logoUrl}/>
                  <div className="tm-icon-wrapper u-pullRight" style={{margin: "10px"}}>
                    <i className="fal fa-badge-check fa-2x" style={{color: "#00BC8B"}} />
                  </div>
                </div>
              :
                <img alt="certificate achieved" src={logoUrl}/>
              }
            </div>
          </div>
          <div className="tm-card">
            <div className="title"> {contentModule.title} </div>
            {contentModule.version ? 
              <p className="-summary"> Version {contentModule.version} </p>
            : null
            }
            {contentModule.trailerVidPath ? 
              <div className="trailer-link" onClick={() => this.setState({trailerModalOpen: true})}>View Trailer
                <i className="fal fa-play-circle fa" />
              </div>
            : 
              <div className="trailer-link"/>
            }
            
          </div>
          <div className="card-footer">
            <div className="yt-row center-vert space-between">
              { pending ?
                // 0. REQUIRES ATTESTATION BEFORE COMPLETE
                <div className="yt-col full" style={{marginBottom: "8px"}}>
                  <div style={{marginBottom: '8px'}} className="alert">VERIFICATION REQUIRED</div>
                  <Link className="yt-btn small rounded warning" to={`/my-certificates/${agendaItem._certificate._id}`}>
                    FINISH
                  </Link>
                </div>
              : agendaItem._certificate && !agendaItem.valid && agendaItem.userModuleTiedToLatestCert ?
                // 1. EXPIRED OR INVALID CERT, HAVEN'T RESTARTED - MUST RESTART
                <div className="yt-col full" style={{marginBottom: "8px"}}>
                  <div style={{marginBottom: '8px'}} className="alert">CERTIFICATE IS EXPIRED!</div>
                  {/* <button className="yt-btn small rounded " onClick={() => this.setState({confirmStartOver: true})}> */}
                  <a className="yt-btn danger" href={`${simUrl}/content-modules/${contentModule._id}/overview`}>
                    Restart Training
                  </a>
                </div>
              : agendaItem._certificate && !agendaItem.valid && agendaItem._userModule ?
                // 2. EXPIRED OR INVALID CERT, HAVE NEVER STARTED - MUST RESTART
                <div className="yt-col full" style={{marginBottom: "8px"}}>
                  <div style={{marginBottom: '8px'}} className="alert">CERTIFICATE IS EXPIRED!</div>
                  {/* <button className="yt-btn small rounded " onClick={() => this.setState({confirmStartOver: true})}> */}
                  <a className="yt-btn danger" href={`${simUrl}/content-modules/${contentModule._id}/overview`}>
                    Restart Training
                  </a>
                </div>
              : agendaItem._certificate && !agendaItem.valid ?
                // 3. EXPIRED OR INVALID CERT, ALREADY RESTARTED THOUGH
                <div className="yt-col full" style={{marginBottom: "8px"}}>
                  <div style={{marginBottom: '8px'}} className="alert">CERTIFICATE IS EXPIRED!</div>
                  <Link className="yt-btn small rounded " to={agendaItem._userModule && agendaItem._userModule._lastNode ? `${linkUrl}/cms/${contentModule.slug}/node/${agendaItem._userModule._lastNode}` : `${linkUrl}/cms/${contentModule.slug}`}>
                    Continue Training
                  </Link>
                </div>
              : expiringSoon && agendaItem.userModuleTiedToLatestCert ?
                // 4. VALID CERT BUT EXPIRING SOON, MUST RESTART
                <div className="yt-col full" style={{marginBottom: "8px"}}>
                  <div style={{marginBottom: '8px'}} className="alert">CERTIFICATE IS EXPIRING SOON!</div>
                  {/* <button className="yt-btn small rounded " onClick={() => this.setState({confirmStartOver: true})}> */}
                  <a className="yt-btn danger" href={`${simUrl}/content-modules/${contentModule._id}/overview`}>
                    Restart Training
                  </a>                  
                </div>
              : expiringSoon ?
                // 5. VALID CERT BUT EXPIRING SOON, ALREADY RESTARTED
                <div className="yt-col full" style={{marginBottom: "8px"}}>
                  <div style={{marginBottom: '8px'}} className="alert">CERTIFICATE IS EXPIRING SOON!</div>
                  <Link className="yt-btn small rounded " to={agendaItem._userModule && agendaItem._userModule._lastNode ? `${linkUrl}/cms/${contentModule.slug}/node/${agendaItem._userModule._lastNode}` : `${linkUrl}/cms/${contentModule.slug}`}>
                    Continue Training
                  </Link>
                </div>
              : agendaItem._certificate ?
                // 6. VALID CERT
                <div className="yt-col full" style={{marginBottom: "8px"}}>
                  <span>
                    <a className="yt-btn muted" href={`${simUrl}/content-modules/${contentModule._id}/user-module/${userModule._id}/nodes/${contentModule._startNode}`}>
                      Review
                    </a>
                    <Link className="yt-btn dark" to={`/my-agenda/cms/${contentModule.slug}/conclusion`}>
                      Print Certificate
                    </Link>
                  </span>
                </div>
              : agendaItem._userModule && agendaItem._userModule._lastNode ?
                // 7. NO CERTS BUT ALREADY STARTED MODULE
                <div className="yt-col full" style={{marginBottom: "8px"}}>
                  <Link className="yt-btn small rounded " to={`${linkUrl}/cms/${contentModule.slug}/node/${agendaItem._userModule._lastNode}`}>
                    Resume
                  </Link>
                </div>
              : 
                // 8. NO CERTS AT ALL, BEGIN
                <div className="yt-col _50" style={{marginBottom: "8px"}}>
                  <Link className="yt-btn small rounded bordered  " to={`${linkUrl}/cms/${contentModule.slug}`}>
                    Begin
                  </Link>
                </div>
              }
            </div>
          </div>
        </div>
        {/* <AlertModal
          alertMessage="Are you sure you want to restart your training?"
          alertTitle={"Confirm Restart Training"}
          closeAction={() => this.setState({confirmStartOver: false})}
          confirmAction={this._handleStartOver}
          confirmText={"Yes, continue"}
          declineAction={() => this.setState({confirmStartOver: false})}
          declineText={"Cancel"}
          isOpen={confirmStartOver}
          type="danger"
        /> */}
        <Modal
          btnColor='info'
          cardSize='jumbo'
          closeAction={() => this.setState({trailerModalOpen: false, contentModule: null})}
          isOpen={trailerModalOpen}
          modalClasses={'info'}
          modalHeader={contentModule.title}
          showButtons={false}
        >
          <VideoPlayer
            adminPreview={false}
            isAutoPlay={true}
            onVideoComplete={() => console.log('done playing')}
            playerId={contentModule._id}
            playlist={videoUtils.returnPlaylist(contentModule.trailerVidPath, contentModule.trailerPosterPath, null)}
            tracking={{
              description: "contentModuleCard-trailer"
              , _contentModule: contentModule._id
            }}
          />
        </Modal>
      </div>
    )
  }
}

AgendaTmCard.propTypes = {
  agendaItem: PropTypes.object.isRequired 
  , certificates: PropTypes.array 
  , dispatch: PropTypes.func.isRequired
  , contentModule: PropTypes.object.isRequired 
  , userModules: PropTypes.array
}

AgendaTmCard.defaultProps = {
  certificates: []
  , userModules: []
}

const mapStoreToProps = (store) => {
  /**
  * NOTE: Yote refer's to the global Redux 'state' as 'store' to keep it mentally
  * differentiated from the React component's internal state
  */
  return {
    sponsorStore: store.sponsor 
  }
}


export default withRouter(connect(mapStoreToProps)(AgendaTmCard));



// WEBPACK FOOTER //
// modules/agenda/components/AgendaTmCard.js.jsx